import React from 'react'
import { XStack, YStack } from 'tamagui'

import { Card } from '@newComponents/Card'
import { Icon } from '@newComponents/Icon'
import { Paragraph } from '@newComponents/Text'
import { Link } from '@newComponents/Link'

import { DocSection } from '../shared/DocSection'
import { DocScreenshot } from '../shared/DocScreenshot'

const Notifications = () => (
  <>
    <Card gap='$4'>
      <Paragraph size='$5'>
        Guild sends email notifications to keep you informed about activity in
        your{' '}
        <Link href='/docs/guilds/overview'>Guilds</Link> and{' '}
        <Link href='/docs/events/overview'>Events</Link>. You can control which
        notifications you receive from your account Settings so you only get the
        updates that matter to you.
      </Paragraph>
      <DocScreenshot
        src='docs/account/user-profile-page.png'
        alt='User profile page — notification preferences are managed from the Settings accessible via your profile'
        caption='Access notification settings from your profile Settings'
      />
    </Card>

    <Card gap='$4'>
      <DocSection id='types-of-notifications' title='Types of Notifications'>
        <YStack gap='$3'>
          <XStack gap='$3' alignItems='flex-start'>
            <Icon name='calendar' size='$5' color='$color' flexShrink={0} marginTop={2} />
            <Paragraph size='$5'>
              <Paragraph size='$5' fontWeight='$7'>Event reminders</Paragraph> —
              Receive a reminder before an Event you have RSVPed to. This helps you
              stay on top of your schedule without needing to check the platform.
            </Paragraph>
          </XStack>
          <XStack gap='$3' alignItems='flex-start'>
            <Icon name='people' size='$5' color='$color' flexShrink={0} marginTop={2} />
            <Paragraph size='$5'>
              <Paragraph size='$5' fontWeight='$7'>Guild updates</Paragraph> — Get
              notified when a Guild you belong to creates a new Event or shares an
              announcement. This keeps you in the loop about upcoming community
              activity.
            </Paragraph>
          </XStack>
          <XStack gap='$3' alignItems='flex-start'>
            <Icon name='projection-screen' size='$5' color='$color' flexShrink={0} marginTop={2} />
            <Paragraph size='$5'>
              <Paragraph size='$5' fontWeight='$7'>New Presentations</Paragraph> —
              Receive a notification when a new Presentation is published in a Guild
              you are a Member of, so you can watch recordings and stay current with
              community content.
            </Paragraph>
          </XStack>
          <XStack gap='$3' alignItems='flex-start'>
            <Icon name='mail' size='$5' color='$color' flexShrink={0} marginTop={2} />
            <Paragraph size='$5'>
              <Paragraph size='$5' fontWeight='$7'>Event messages</Paragraph> — When
              an Organizer sends a message to Event attendees, you receive it via
              email. See{' '}
              <Link href='/docs/events/messages'>Event Messages</Link> for more on
              how Organizers communicate with attendees.
            </Paragraph>
          </XStack>
        </YStack>
      </DocSection>
    </Card>

    <Card gap='$4'>
      <DocSection id='managing-notifications' title='Managing Your Preferences'>
        <Paragraph size='$5'>
          To adjust your notification preferences, click your profile photo in the
          top-right corner of the navigation bar and select{' '}
          <Paragraph size='$5' fontWeight='$7'>Settings</Paragraph>. Navigate to
          the notifications section where you can toggle individual notification
          types on or off.
        </Paragraph>
        <Paragraph size='$5'>
          Changes to your notification preferences take effect immediately. You
          can return to the Settings page at any time to update them.
        </Paragraph>
      </DocSection>
    </Card>

    <Card gap='$4'>
      <DocSection id='unsubscribing' title='Unsubscribing from Emails'>
        <Paragraph size='$5'>
          Every notification email from Guild includes an unsubscribe link at the
          bottom. Clicking it will take you directly to your notification Settings
          where you can turn off that notification type. This provides a quick way
          to manage preferences without navigating through the platform.
        </Paragraph>
      </DocSection>
    </Card>
  </>
)

export default Notifications
